<template>
  <div class="step-box">
    <div class="step-head">第二步 提交个人信息</div>
    <div class="step-body">
      <a-form-model
        ref="form"
        :model="form"
        :rules="rules"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-model-item label="参赛选手姓名" prop="realName">
          <a-input v-model="form.realName" placeholder="填写选手的真实姓名" />
        </a-form-model-item>
        <a-form-model-item label="身份证号" prop="idNumber">
          <a-input v-model="form.idNumber" placeholder="填写选手的身份证号" />
        </a-form-model-item>
        <a-form-model-item label="出生日期" prop="birthday">
          <a-date-picker
            v-model="form.birthday"
            :format="dateFormat"
            :locale="locale"
            style="width: 100%"
            placeholder="选择选手身份证上的出生日期"
          />
        </a-form-model-item>
        <a-form-model-item label="所在地区" prop="address">
          <a-cascader
            v-model="form.address"
            :options="areaData"
            :fieldNames="fieldName"
            placeholder="选择选手所在省市县"
          ></a-cascader>
        </a-form-model-item>
        <a-form-model-item label="学校名称" prop="organizationName">
          <a-input
            v-model="form.organizationName"
            placeholder="填写学校或机构的统一名称"
          />
        </a-form-model-item>
        <a-form-model-item label="指导教师姓名" prop="teacherName">
          <a-input
            v-model="form.teacherName"
            placeholder="填写指导教师真实姓名"
          />
        </a-form-model-item>
        <a-form-model-item label="联系电话" prop="phoneNumber">
          <a-input
            v-model="form.phoneNumber"
            placeholder="请务必填写有效联系电话"
          />
        </a-form-model-item>
        <a-form-model-item label="电子邮箱" prop="email">
          <a-input v-model="form.email" placeholder="请务必填写有效电子邮箱" />
        </a-form-model-item>
        <a-form-model-item label="队伍成员姓名" prop="teamMemberName">
          <a-input
            v-model="form.teamMemberName"
            placeholder="请填写队伍成员的真实姓名，若无则不填写"
          />
        </a-form-model-item>
      </a-form-model>
      <div class="op-box">
        <a href="javascript:" class="btn secondary" @click="prev()">上一步</a>
        <a href="javascript:" class="btn primary" @click="submitInformation"
          >下一步</a
        >
      </div>
    </div>
    <Modal
      :show-modal="showAlertModal"
      :need-pic="false"
      :msg="alertMsg"
      :need-cancel="false"
      @confirmModal="confirmAlertModal"
    ></Modal>
  </div>
</template>

<script>
import { FormModel, Input, DatePicker, Cascader } from 'ant-design-vue'
import locale from 'ant-design-vue/lib/date-picker/locale/zh_CN'
import moment from 'moment'
import areaData from '../../assets/json/area.json'
import Modal from '../../components/modal'

export default {
  name: 'information',
  components: {
    AFormModel: FormModel,
    AFormModelItem: FormModel.Item,
    AInput: Input,
    ADatePicker: DatePicker,
    ACascader: Cascader,
    Modal,
  },
  props: {
    prev: Function,
    userInformation: Object,
    gameInfo: Object,
    userInfo: Object
  },
  created() {
    this.init()
  },
  data() {
    return {
      dateFormat: 'YYYY-MM-DD',
      locale,
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
      form: {
        realName: '',
        idNumber: '',
        birthday: undefined,
        phoneNumber: '',
        email: '',
        address: undefined,
        organizationName: '',
        teacherName: '',
        teamMemberName: '',
      },
      rules: {
        realName: [
          { required: true, message: '参赛选手姓名不能为空' },
          { min: 1, max: 128, message: '字符数超出限制' },
        ],
        idNumber: [
          { required: true, message: '参赛选手身份证号不能为空' },
          { min: 1, max: 128, message: '字符数超出限制' },
          {
            pattern:
              '^[1-9]\\d{5}(18|19|([23]\\d))\\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\\d{3}[0-9Xx]$',
            message: '请输入正确的身份证号',
          },
        ],
        birthday: [{ required: true, message: '出生日期不能为空' }],
        address: [{ required: true, message: '所在地区不能为空' }],
        organizationName: [
          { required: true, message: '学校名称不能为空' },
          { min: 1, max: 128, message: '字符数超出限制' },
        ],
        teacherName: [
          { required: true, message: '指导教师姓名不能为空' },
          { min: 1, max: 128, message: '字符数超出限制' },
        ],
        phoneNumber: [
          { required: true, message: '联系电话不能为空' },
          { pattern: '^\\d{1,128}$', message: '请输入正确的电话号码' },
        ],
        email: [
          { required: true, message: '电子邮箱不能为空' },
          { min: 1, max: 128, message: '字符数超出限制' },
          {
            pattern:
              '[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\\.[a-zA-Z0-9-]+)*\\.[a-zA-Z0-9]{2,6}$',
            message: '请输入正确的电子邮箱',
          },
        ],
        teamMemberName: [
            { min: 0, max: 128, message: '字符数超出限制' }
        ]
      },
      areaData,
      fieldName: {
        label: 'name',
        value: 'name',
        children: 'children',
      },
      showAlertModal: false,
      alertMsg: '',
    }
  },
  methods: {
    moment,
    init() {
      moment.locale('zh-CN')
      if (this.userInformation) {
        this.form = this.userInformation
      }
    },
    submitInformation() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.$axios
            .post(
              '/game/v1/verify-user',
              {
                gameId: this.gameInfo.id,
                realName: this.form.realName,
                idNumber: this.form.idNumber,
              },
              {
                headers: {
                  utoken: this.userInfo.utoken,
                },
              }
            )
            .then((resp) => {
              if (resp.data.code === 0) {
                  this.$emit('getUserInformation', this.form)
              } else if (resp.data.code === 10000) {
                this.alertMsg = resp.data.message
                this.showAlertModal = true
              } else {
                 this.alertMsg = '系统异常，请稍后重试'
                 this.showAlertModal = true
              }
            })
          
        } else {
          return false
        }
      })
    },
    confirmAlertModal() {
      this.showAlertModal = false
    },
  },
}
</script>

<style scoped></style>
